const isArray = (data: any) => {
  return Array.isArray(data);
};

export default isArray;
